import {
    semanticBackgroundColors,
    semanticBodyColors,
    semanticBorderColors,
    semanticHeadingColors,
    semanticLinkColors,
    semanticTokens,
    semanticValidationColors,
} from './semanticTokens';

export const numericSpacing = {
    '0': 0,
    px: 1,
    '0.5': 2,
    '1': 4,
    '1.5': 6,
    '2': 8,
    '2.5': 10,
    '3': 12,
    '4': 16,
    '5': 20,
    '6': 24,
    '7': 28,
    '8': 32,
    '9': 36,
    '10': 40,
    '11': 44,
    '12': 48,
    '14': 56,
    '16': 64,
    '20': 80,
    '24': 96,
    '28': 112,
    '32': 128,
} as const;

export const spacing = {
    '0': `${numericSpacing['0']}`,
    px: `${numericSpacing.px}px`,
    '0.5': `${numericSpacing['0.5']}px`,
    '1': `${numericSpacing['1']}px`,
    '1.5': `${numericSpacing['1.5']}px`,
    '2': `${numericSpacing['2']}px`,
    '2.5': `${numericSpacing['2.5']}px`,
    '3': `${numericSpacing['3']}px`,
    '4': `${numericSpacing['4']}px`,
    '5': `${numericSpacing['5']}px`,
    '6': `${numericSpacing['6']}px`,
    '7': `${numericSpacing['7']}px`,
    '8': `${numericSpacing['8']}px`,
    '9': `${numericSpacing['9']}px`,
    '10': `${numericSpacing['10']}px`,
    '11': `${numericSpacing['11']}px`,
    '12': `${numericSpacing['12']}px`,
    '14': `${numericSpacing['14']}px`,
    '16': `${numericSpacing['16']}px`,
    '20': `${numericSpacing['20']}px`,
    '24': `${numericSpacing['24']}px`,
    '28': `${numericSpacing['28']}px`,
    '32': `${numericSpacing['32']}px`,
} as const;

export const margin = {
    auto: 'auto',
    autoX: '0 auto',
    autoY: 'auto 0',
} as const;

export const blueColors = {
    /**
     * Color: <span style="padding: 4px; background-color: #F0F4FF; color: #000000">#F0F4FF</span>
     */
    blue_100: '#F0F4FF',
    /**
     * Color: <span style="padding: 4px; background-color: #D4DEFB; color: #000000">#D4DEFB</span>
     */
    blue_200: '#D4DEFB',
    /**
     * Color: <span style="padding: 4px; background-color: #B9C9F7; color: #000000">#B9C9F7</span>
     */
    blue_300: '#B9C9F7',
    /**
     * Color: <span style="padding: 4px; background-color: #9DB4F3; color: #000000">#9DB4F3</span>
     */
    blue_400: '#9DB4F3',
    /**
     * Color: <span style="padding: 4px; background-color: #819EF0; color: #000000">#819EF0</span>
     */
    blue_500: '#819EF0',
    /**
     * Color: <span style="padding: 4px; background-color: #6689EC; color: #FFFFFF">#6689EC</span>
     */
    blue_600: '#6689EC',
    /**
     * Color: <span style="padding: 4px; background-color: #446EE7; color: #FFFFFF">#446EE7</span>
     */
    blue_700: '#446EE7',
    /**
     * Color: <span style="padding: 4px; background-color: #3F63C8; color: #FFFFFF">#3F63C8</span>
     */
    blue_800: '#3F63C8',
    /**
     * Color: <span style="padding: 4px; background-color: #3453A8; color: #FFFFFF">#3453A8</span>
     */
    blue_900: '#3453A8',
    /**
     * Color: <span style="padding: 4px; background-color: #284389; color: #FFFFFF">#284389</span>
     */
    blue_1000: '#284389',
    /**
     * Color: <span style="padding: 4px; background-color: #1D3369; color: #FFFFFF">#1D3369</span>
     */
    blue_1100: '#1D3369',
    /**
     * Color: <span style="padding: 4px; background-color: #122349; color: #FFFFFF">#122349</span>
     */
    blue_1200: '#122349',
} as const;

export const businessColors = {
    /**
     * Color: <span style="padding: 4px; background-color: #F2F5FF; color: #000000">#F2F5FF</span>
     */
    business_100: '#F2F5FF',
    /**
     * Color: <span style="padding: 4px; background-color: #E6EBFF; color: #000000">#E6EBFF</span>
     */
    business_200: '#E6EBFF',
    /**
     * Color: <span style="padding: 4px; background-color: #DCDFFF; color: #000000">#DCDFFF</span>
     */
    business_300: '#DCDFFF',
    /**
     * Color: <span style="padding: 4px; background-color: #D2D3FF; color: #000000">#D2D3FF</span>
     */
    business_400: '#D2D3FF',
    /**
     * Color: <span style="padding: 4px; background-color: #BBB9FF; color: #000000">#BBB9FF</span>
     */
    business_500: '#BBB9FF',
    /**
     * Color: <span style="padding: 4px; background-color: #A6A1FF; color: #000000">#A6A1FF</span>
     */
    business_600: '#A6A1FF',
    /**
     * Color: <span style="padding: 4px; background-color: #8E88FF; color: #000000">#8E88FF</span>
     */
    business_700: '#8E88FF',
    /**
     * Color: <span style="padding: 4px; background-color: #6460E6; color: #FFFFFF">#6460E6</span>
     */
    business_800: '#6460E6',
    /**
     * Color: <span style="padding: 4px; background-color: #504DBF; color: #FFFFFF">#504DBF</span>
     */
    business_900: '#504DBF',
    /**
     * Color: <span style="padding: 4px; background-color: #3C3A99; color: #FFFFFF">#3C3A99</span>
     */
    business_1000: '#3C3A99',
    /**
     * Color: <span style="padding: 4px; background-color: #282773; color: #FFFFFF">#282773</span>
     */
    business_1100: '#282773',
    /**
     * Color: <span style="padding: 4px; background-color: #18184D; color: #FFFFFF">#18184D</span>
     */
    business_1200: '#18184D',
} as const;

export const greenColors = {
    /**
     * Color: <span style="padding: 4px; background-color: #E8FAF4; color: #000000">#E8FAF4</span>
     */
    green_100: '#E8FAF4',
    /**
     * Color: <span style="padding: 4px; background-color: #D0F7E6; color: #000000">#D0F7E6</span>
     */
    green_200: '#D0F7E6',
    /**
     * Color: <span style="padding: 4px; background-color: #A6EACA; color: #000000">#A6EACA</span>
     */
    green_300: '#A6EACA',
    /**
     * Color: <span style="padding: 4px; background-color: #84DFB5; color: #000000">#84DFB5</span>
     */
    green_400: '#84DFB5',
    /**
     * Color: <span style="padding: 4px; background-color: #62D49F; color: #000000">#62D49F</span>
     */
    green_500: '#62D49F',
    /**
     * Color: <span style="padding: 4px; background-color: #3FCA89; color: #000000">#3FCA89</span>
     */
    green_600: '#3FCA89',
    /**
     * Color: <span style="padding: 4px; background-color: #1DBF73; color: #000000">#1DBF73</span>
     */
    green_700: '#1DBF73',
    /**
     * Color: <span style="padding: 4px; background-color: #00AA5A; color: #FFFFFF">#00AA5A</span>
     */
    green_800: '#00AA5A',
    /**
     * Color: <span style="padding: 4px; background-color: #008A37; color: #FFFFFF">#008A37</span>
     */
    green_900: '#008A37',
    /**
     * Color: <span style="padding: 4px; background-color: #00732E; color: #FFFFFF">#00732E</span>
     */
    green_1000: '#00732E',
    /**
     * Color: <span style="padding: 4px; background-color: #005C25; color: #FFFFFF">#005C25</span>
     */
    green_1100: '#005C25',
    /**
     * Color: <span style="padding: 4px; background-color: #003912; color: #FFFFFF">#003912</span>
     */
    green_1200: '#003912',
} as const;

export const greyColors = {
    /**
     * Color: <span style="padding: 4px; background-color: #FAFAFA; color: #000000">#FAFAFA</span>
     */
    grey_100: '#FAFAFA',
    /**
     * Color: <span style="padding: 4px; background-color: #F5F5F5; color: #000000">#F5F5F5</span>
     */
    grey_200: '#F5F5F5',
    /**
     * Color: <span style="padding: 4px; background-color: #EFEFF0; color: #000000">#EFEFF0</span>
     */
    grey_300: '#EFEFF0',
    /**
     * Color: <span style="padding: 4px; background-color: #E4E5E7; color: #000000">#E4E5E7</span>
     */
    grey_400: '#E4E5E7',
    /**
     * Color: <span style="padding: 4px; background-color: #DADBDD; color: #000000">#DADBDD</span>
     */
    grey_500: '#DADBDD',
    /**
     * Color: <span style="padding: 4px; background-color: #C5C6C9; color: #000000">#C5C6C9</span>
     */
    grey_600: '#C5C6C9',
    /**
     * Color: <span style="padding: 4px; background-color: #B5B6BA; color: #000000">#B5B6BA</span>
     */
    grey_700: '#B5B6BA',
    /**
     * Color: <span style="padding: 4px; background-color: #95979D; color: #FFFFFF">#95979D</span>
     */
    grey_800: '#95979D',
    /**
     * Color: <span style="padding: 4px; background-color: #74767E; color: #FFFFFF">#74767E</span>
     */
    grey_900: '#74767E',
    /**
     * Color: <span style="padding: 4px; background-color: #62646A; color: #FFFFFF">#62646A</span>
     */
    grey_1000: '#62646A',
    /**
     * Color: <span style="padding: 4px; background-color: #404145; color: #FFFFFF">#404145</span>
     */
    grey_1100: '#404145',
    /**
     * Color: <span style="padding: 4px; background-color: #222325; color: #FFFFFF">#222325</span>
     */
    grey_1200: '#222325',
} as const;

export const lightOrangeColors = {
    /**
     * Color: <span style="padding: 4px; background-color: #F8F9E5; color: #000000">#F8F9E5</span>
     */
    lightOrange_100: '#F8F9E5',
    /**
     * Color: <span style="padding: 4px; background-color: #F1F4CB; color: #000000">#F1F4CB</span>
     */
    lightOrange_200: '#F1F4CB',
    /**
     * Color: <span style="padding: 4px; background-color: #EDF2B3; color: #000000">#EDF2B3</span>
     */
    lightOrange_300: '#EDF2B3',
    /**
     * Color: <span style="padding: 4px; background-color: #E8F094; color: #000000">#E8F094</span>
     */
    lightOrange_400: '#E8F094',
    /**
     * Color: <span style="padding: 4px; background-color: #E3EE74; color: #000000">#E3EE74</span>
     */
    lightOrange_500: '#E3EE74',
    /**
     * Color: <span style="padding: 4px; background-color: #DAEA3D; color: #000000">#DAEA3D</span>
     */
    lightOrange_600: '#DAEA3D',
    /**
     * Color: <span style="padding: 4px; background-color: #D0E500; color: #000000">#D0E500</span>
     */
    lightOrange_700: '#D0E500',
    /**
     * Color: <span style="padding: 4px; background-color: #BBCE00; color: #000000">#BBCE00</span>
     */
    lightOrange_800: '#BBCE00',
    /**
     * Color: <span style="padding: 4px; background-color: #7D8900; color: #FFFFFF">#7D8900</span>
     */
    lightOrange_900: '#7D8900',
    /**
     * Color: <span style="padding: 4px; background-color: #687200; color: #FFFFFF">#687200</span>
     */
    lightOrange_1000: '#687200',
    /**
     * Color: <span style="padding: 4px; background-color: #465A00; color: #FFFFFF">#465A00</span>
     */
    lightOrange_1100: '#465A00',
    /**
     * Color: <span style="padding: 4px; background-color: #254200; color: #FFFFFF">#254200</span>
     */
    lightOrange_1200: '#254200',
} as const;

export const orangeColors = {
    /**
     * Color: <span style="padding: 4px; background-color: #FFF6F2; color: #000000">#FFF6F2</span>
     */
    orange_100: '#FFF6F2',
    /**
     * Color: <span style="padding: 4px; background-color: #FFE0D4; color: #000000">#FFE0D4</span>
     */
    orange_200: '#FFE0D4',
    /**
     * Color: <span style="padding: 4px; background-color: #FFC9B4; color: #000000">#FFC9B4</span>
     */
    orange_300: '#FFC9B4',
    /**
     * Color: <span style="padding: 4px; background-color: #FFA987; color: #000000">#FFA987</span>
     */
    orange_400: '#FFA987',
    /**
     * Color: <span style="padding: 4px; background-color: #FF976E; color: #000000">#FF976E</span>
     */
    orange_500: '#FF976E',
    /**
     * Color: <span style="padding: 4px; background-color: #FF8758; color: #000000">#FF8758</span>
     */
    orange_600: '#FF8758',
    /**
     * Color: <span style="padding: 4px; background-color: #FF7640; color: #000000">#FF7640</span>
     */
    orange_700: '#FF7640',
    /**
     * Color: <span style="padding: 4px; background-color: #E0612E; color: #FFFFFF">#E0612E</span>
     */
    orange_800: '#E0612E',
    /**
     * Color: <span style="padding: 4px; background-color: #C65325; color: #FFFFFF">#C65325</span>
     */
    orange_900: '#C65325',
    /**
     * Color: <span style="padding: 4px; background-color: #8F2900; color: #FFFFFF">#8F2900</span>
     */
    orange_1000: '#8F2900',
    /**
     * Color: <span style="padding: 4px; background-color: #6F2000; color: #FFFFFF">#6F2000</span>
     */
    orange_1100: '#6F2000',
    /**
     * Color: <span style="padding: 4px; background-color: #421300; color: #FFFFFF">#421300</span>
     */
    orange_1200: '#421300',
} as const;

export const pinkColors = {
    /**
     * Color: <span style="padding: 4px; background-color: #FFF5F8; color: #000000">#FFF5F8</span>
     */
    pink_100: '#FFF5F8',
    /**
     * Color: <span style="padding: 4px; background-color: #FFD3E2; color: #000000">#FFD3E2</span>
     */
    pink_200: '#FFD3E2',
    /**
     * Color: <span style="padding: 4px; background-color: #FFC3D8; color: #000000">#FFC3D8</span>
     */
    pink_300: '#FFC3D8',
    /**
     * Color: <span style="padding: 4px; background-color: #FFB1CD; color: #000000">#FFB1CD</span>
     */
    pink_400: '#FFB1CD',
    /**
     * Color: <span style="padding: 4px; background-color: #FFA1C3; color: #000000">#FFA1C3</span>
     */
    pink_500: '#FFA1C3',
    /**
     * Color: <span style="padding: 4px; background-color: #FF8EB7; color: #000000">#FF8EB7</span>
     */
    pink_600: '#FF8EB7',
    /**
     * Color: <span style="padding: 4px; background-color: #FF80AE; color: #000000">#FF80AE</span>
     */
    pink_700: '#FF80AE',
    /**
     * Color: <span style="padding: 4px; background-color: #EF6D94; color: #000000">#EF6D94</span>
     */
    pink_800: '#EF6D94',
    /**
     * Color: <span style="padding: 4px; background-color: #D95F83; color: #FFFFFF">#D95F83</span>
     */
    pink_900: '#D95F83',
    /**
     * Color: <span style="padding: 4px; background-color: #BE5272; color: #FFFFFF">#BE5272</span>
     */
    pink_1000: '#BE5272',
    /**
     * Color: <span style="padding: 4px; background-color: #983E59; color: #FFFFFF">#983E59</span>
     */
    pink_1100: '#983E59',
    /**
     * Color: <span style="padding: 4px; background-color: #4D1727; color: #FFFFFF">#4D1727</span>
     */
    pink_1200: '#4D1727',
} as const;

export const purpleColors = {
    /**
     * Color: <span style="padding: 4px; background-color: #F8F0FF; color: #000000">#F8F0FF</span>
     */
    purple_100: '#F8F0FF',
    /**
     * Color: <span style="padding: 4px; background-color: #E8D4FB; color: #000000">#E8D4FB</span>
     */
    purple_200: '#E8D4FB',
    /**
     * Color: <span style="padding: 4px; background-color: #D8B9F7; color: #000000">#D8B9F7</span>
     */
    purple_300: '#D8B9F7',
    /**
     * Color: <span style="padding: 4px; background-color: #C89DF3; color: #000000">#C89DF3</span>
     */
    purple_400: '#C89DF3',
    /**
     * Color: <span style="padding: 4px; background-color: #B881F0; color: #000000">#B881F0</span>
     */
    purple_500: '#B881F0',
    /**
     * Color: <span style="padding: 4px; background-color: #A866EC; color: #000000">#A866EC</span>
     */
    purple_600: '#A866EC',
    /**
     * Color: <span style="padding: 4px; background-color: #984AE8; color: #FFFFFF">#984AE8</span>
     */
    purple_700: '#984AE8',
    /**
     * Color: <span style="padding: 4px; background-color: #8842D0; color: #FFFFFF">#8842D0</span>
     */
    purple_800: '#8842D0',
    /**
     * Color: <span style="padding: 4px; background-color: #7739B9; color: #FFFFFF">#7739B9</span>
     */
    purple_900: '#7739B9',
    /**
     * Color: <span style="padding: 4px; background-color: #6731A1; color: #FFFFFF">#6731A1</span>
     */
    purple_1000: '#6731A1',
    /**
     * Color: <span style="padding: 4px; background-color: #56288A; color: #FFFFFF">#56288A</span>
     */
    purple_1100: '#56288A',
    /**
     * Color: <span style="padding: 4px; background-color: #462072; color: #FFFFFF">#462072</span>
     */
    purple_1200: '#462072',
} as const;

export const redColors = {
    /**
     * Color: <span style="padding: 4px; background-color: #FFEDED; color: #000000">#FFEDED</span>
     */
    red_100: '#FFEDED',
    /**
     * Color: <span style="padding: 4px; background-color: #FED0D0; color: #000000">#FED0D0</span>
     */
    red_200: '#FED0D0',
    /**
     * Color: <span style="padding: 4px; background-color: #FCB3B3; color: #000000">#FCB3B3</span>
     */
    red_300: '#FCB3B3',
    /**
     * Color: <span style="padding: 4px; background-color: #FB9797; color: #000000">#FB9797</span>
     */
    red_400: '#FB9797',
    /**
     * Color: <span style="padding: 4px; background-color: #FA7A7A; color: #000000">#FA7A7A</span>
     */
    red_500: '#FA7A7A',
    /**
     * Color: <span style="padding: 4px; background-color: #F85D5D; color: #FFFFFF">#F85D5D</span>
     */
    red_600: '#F85D5D',
    /**
     * Color: <span style="padding: 4px; background-color: #F74040; color: #FFFFFF">#F74040</span>
     */
    red_700: '#F74040',
    /**
     * Color: <span style="padding: 4px; background-color: #D93C3C; color: #FFFFFF">#D93C3C</span>
     */
    red_800: '#D93C3C',
    /**
     * Color: <span style="padding: 4px; background-color: #C43333; color: #FFFFFF">#C43333</span>
     */
    red_900: '#C43333',
    /**
     * Color: <span style="padding: 4px; background-color: #AB2D2D; color: #FFFFFF">#AB2D2D</span>
     */
    red_1000: '#AB2D2D',
    /**
     * Color: <span style="padding: 4px; background-color: #912626; color: #FFFFFF">#912626</span>
     */
    red_1100: '#912626',
    /**
     * Color: <span style="padding: 4px; background-color: #782020; color: #FFFFFF">#782020</span>
     */
    red_1200: '#782020',
} as const;

export const tealColors = {
    /**
     * Color: <span style="padding: 4px; background-color: #ECFCFF; color: #000000">#ECFCFF</span>
     */
    teal_100: '#ECFCFF',
    /**
     * Color: <span style="padding: 4px; background-color: #CDF5FB; color: #000000">#CDF5FB</span>
     */
    teal_200: '#CDF5FB',
    /**
     * Color: <span style="padding: 4px; background-color: #AFEDF7; color: #000000">#AFEDF7</span>
     */
    teal_300: '#AFEDF7',
    /**
     * Color: <span style="padding: 4px; background-color: #92E6F3; color: #000000">#92E6F3</span>
     */
    teal_400: '#92E6F3',
    /**
     * Color: <span style="padding: 4px; background-color: #75DFEE; color: #000000">#75DFEE</span>
     */
    teal_500: '#75DFEE',
    /**
     * Color: <span style="padding: 4px; background-color: #57D7EA; color: #000000">#57D7EA</span>
     */
    teal_600: '#57D7EA',
    /**
     * Color: <span style="padding: 4px; background-color: #3AD0E6; color: #000000">#3AD0E6</span>
     */
    teal_700: '#3AD0E6',
    /**
     * Color: <span style="padding: 4px; background-color: #30B8CB; color: #000000">#30B8CB</span>
     */
    teal_800: '#30B8CB',
    /**
     * Color: <span style="padding: 4px; background-color: #25A1B0; color: #FFFFFF">#25A1B0</span>
     */
    teal_900: '#25A1B0',
    /**
     * Color: <span style="padding: 4px; background-color: #1B8996; color: #FFFFFF">#1B8996</span>
     */
    teal_1000: '#1B8996',
    /**
     * Color: <span style="padding: 4px; background-color: #10727B; color: #FFFFFF">#10727B</span>
     */
    teal_1100: '#10727B',
    /**
     * Color: <span style="padding: 4px; background-color: #065A60; color: #FFFFFF">#065A60</span>
     */
    teal_1200: '#065A60',
} as const;

export const yellowColors = {
    /**
     * Color: <span style="padding: 4px; background-color: #FFF7EE; color: #000000">#FFF7EE</span>
     */
    yellow_100: '#FFF7EE',
    /**
     * Color: <span style="padding: 4px; background-color: #FFECD1; color: #000000">#FFECD1</span>
     */
    yellow_200: '#FFECD1',
    /**
     * Color: <span style="padding: 4px; background-color: #FFE0B3; color: #000000">#FFE0B3</span>
     */
    yellow_300: '#FFE0B3',
    /**
     * Color: <span style="padding: 4px; background-color: #FFD596; color: #000000">#FFD596</span>
     */
    yellow_400: '#FFD596',
    /**
     * Color: <span style="padding: 4px; background-color: #FFCA79; color: #000000">#FFCA79</span>
     */
    yellow_500: '#FFCA79',
    /**
     * Color: <span style="padding: 4px; background-color: #FFBE5B; color: #000000">#FFBE5B</span>
     */
    yellow_600: '#FFBE5B',
    /**
     * Color: <span style="padding: 4px; background-color: #FFB33E; color: #000000">#FFB33E</span>
     */
    yellow_700: '#FFB33E',
    /**
     * Color: <span style="padding: 4px; background-color: #E6A139; color: #000000">#E6A139</span>
     */
    yellow_800: '#E6A139',
    /**
     * Color: <span style="padding: 4px; background-color: #CD8E33; color: #000000">#CD8E33</span>
     */
    yellow_900: '#CD8E33',
    /**
     * Color: <span style="padding: 4px; background-color: #B47C2E; color: #FFFFFF">#B47C2E</span>
     */
    yellow_1000: '#B47C2E',
    /**
     * Color: <span style="padding: 4px; background-color: #9B6928; color: #FFFFFF">#9B6928</span>
     */
    yellow_1100: '#9B6928',
    /**
     * Color: <span style="padding: 4px; background-color: #825723; color: #FFFFFF">#825723</span>
     */
    yellow_1200: '#825723',
} as const;

export const whiteColors = {
    /**
     * Color: <span style="padding: 4px; background-color: #fff; color: #000000">#fff</span>
     */
    white: '#fff',
    /**
     * Color: <span style="padding: 4px; background-color: rgba(255, 255, 255, 0.1); color: #000000">rgba(255, 255, 255, 0.1)</span>
     */
    white_10: 'rgba(255, 255, 255, 0.1)',
    /**
     * Color: <span style="padding: 4px; background-color: rgba(255, 255, 255, 0.2); color: #000000">rgba(255, 255, 255, 0.2)</span>
     */
    white_20: 'rgba(255, 255, 255, 0.2)',
    /**
     * Color: <span style="padding: 4px; background-color: rgba(255, 255, 255, 0.3); color: #000000">rgba(255, 255, 255, 0.3)</span>
     */
    white_30: 'rgba(255, 255, 255, 0.3)',
    /**
     * Color: <span style="padding: 4px; background-color: rgba(255, 255, 255, 0.4); color: #000000">rgba(255, 255, 255, 0.4)</span>
     */
    white_40: 'rgba(255, 255, 255, 0.4)',
    /**
     * Color: <span style="padding: 4px; background-color: rgba(255, 255, 255, 0.5); color: #000000">rgba(255, 255, 255, 0.5)</span>
     */
    white_50: 'rgba(255, 255, 255, 0.5)',
    /**
     * Color: <span style="padding: 4px; background-color: rgba(255, 255, 255, 0.6); color: #000000">rgba(255, 255, 255, 0.6)</span>
     */
    white_60: 'rgba(255, 255, 255, 0.6)',
    /**
     * Color: <span style="padding: 4px; background-color: rgba(255, 255, 255, 0.7); color: #000000">rgba(255, 255, 255, 0.7)</span>
     */
    white_70: 'rgba(255, 255, 255, 0.7)',
    /**
     * Color: <span style="padding: 4px; background-color: rgba(255, 255, 255, 0.8); color: #000000">rgba(255, 255, 255, 0.8)</span>
     */
    white_80: 'rgba(255, 255, 255, 0.8)',
    /**
     * Color: <span style="padding: 4px; background-color: rgba(255, 255, 255, 0.9); color: #000000">rgba(255, 255, 255, 0.9)</span>
     */
    white_90: 'rgba(255, 255, 255, 0.9)',
} as const;

export const blackColors = {
    /**
     * Color: <span style="padding: 4px; background-color: #0C0C0D; color: #FFFFFF">#0C0C0D</span>
     */
    black: '#0C0C0D',
    /**
     * Color: <span style="padding: 4px; background-color: rgba(12, 12, 13, 0.1); color: #000000">rgba(12, 12, 13, 0.1)</span>
     */
    black_10: 'rgba(12, 12, 13, 0.1)',
    /**
     * Color: <span style="padding: 4px; background-color: rgba(12, 12, 13, 0.2); color: #000000">rgba(12, 12, 13, 0.2)</span>
     */
    black_20: 'rgba(12, 12, 13, 0.2)',
    /**
     * Color: <span style="padding: 4px; background-color: rgba(12, 12, 13, 0.3); color: #000000">rgba(12, 12, 13, 0.3)</span>
     */
    black_30: 'rgba(12, 12, 13, 0.3)',
    /**
     * Color: <span style="padding: 4px; background-color: rgba(12, 12, 13, 0.4); color: #FFFFFF">rgba(12, 12, 13, 0.4)</span>
     */
    black_40: 'rgba(12, 12, 13, 0.4)',
    /**
     * Color: <span style="padding: 4px; background-color: rgba(12, 12, 13, 0.5); color: #FFFFFF">rgba(12, 12, 13, 0.5)</span>
     */
    black_50: 'rgba(12, 12, 13, 0.5)',
    /**
     * Color: <span style="padding: 4px; background-color: rgba(12, 12, 13, 0.6); color: #FFFFFF">rgba(12, 12, 13, 0.6)</span>
     */
    black_60: 'rgba(12, 12, 13, 0.6)',
    /**
     * Color: <span style="padding: 4px; background-color: rgba(12, 12, 13, 0.7); color: #FFFFFF">rgba(12, 12, 13, 0.7)</span>
     */
    black_70: 'rgba(12, 12, 13, 0.7)',
    /**
     * Color: <span style="padding: 4px; background-color: rgba(12, 12, 13, 0.8); color: #FFFFFF">rgba(12, 12, 13, 0.8)</span>
     */
    black_80: 'rgba(12, 12, 13, 0.8)',
    /**
     * Color: <span style="padding: 4px; background-color: rgba(12, 12, 13, 0.9); color: #FFFFFF">rgba(12, 12, 13, 0.9)</span>
     */
    black_90: 'rgba(12, 12, 13, 0.9)',
} as const;

export const gradientColors = {
    gradient_blue: `linear-gradient(180deg, ${blueColors.blue_200} 0%, ${blueColors.blue_600} 100%)`,
    gradient_red: `linear-gradient(180deg, ${redColors.red_200} 0%, ${redColors.red_400} 100%)`,
    gradient_pink: `linear-gradient(180deg, ${pinkColors.pink_200} 0%, ${pinkColors.pink_400} 100%)`,
    gradient_orange: `linear-gradient(180deg, ${orangeColors.orange_200} 0%, ${orangeColors.orange_500} 100%)`,
    gradient_yellow: `linear-gradient(180deg, ${yellowColors.yellow_200} 0%, ${yellowColors.yellow_500} 100%)`,
    gradient_purple: `linear-gradient(180deg, ${purpleColors.purple_200} 0%, ${purpleColors.purple_500} 100%)`,
} as const;

export const colors = {
    transparent: 'transparent',
    inherit: 'inherit',
    currentColor: 'currentColor',
    ...blackColors,
    ...whiteColors,
    ...blueColors,
    ...businessColors,
    ...greenColors,
    ...greyColors,
    ...lightOrangeColors,
    ...orangeColors,
    ...pinkColors,
    ...purpleColors,
    ...redColors,
    ...tealColors,
    ...yellowColors,
    ...gradientColors,
} as const;

export const backgroundColors = {
    ...semanticBackgroundColors,
    ...colors,
} as const;

export const validationColors = {
    validationError: semanticTokens.validationError,
    validationInformation: semanticTokens.validationInformation,
    validationSuccess: semanticTokens.validationSuccess,
    validationWarning: semanticTokens.validationWarning,
} as const;

export const bodyColors = {
    white: colors.white,
    inherit: colors.inherit,
    ...semanticBodyColors,
    ...validationColors,
};

export const headingColors = {
    white: colors.white,
    inherit: colors.inherit,
    ...semanticHeadingColors,
};

export const linkColors = {
    ...semanticLinkColors,
    ...colors,
} as const;

export const typographyColors = {
    ...linkColors,
    ...headingColors,
    ...bodyColors,
    ...colors,
} as const;

export const borderColors = {
    ...semanticBorderColors,
    ...validationColors,
    ...colors,
} as const;

export const borderStyle = {
    dashed: 'dashed',
    solid: 'solid',
} as const;

export const outlineStyle = {
    solid: 'solid',
} as const;

export const boxShadows = {
    aa: '0 0 .880517px rgba(0, 0, 0, .0288), 0 0 2.29197px rgba(0, 0, 0, .03), 0 0 5.52px rgba(0, 0, 0, .0543), 0 0 11px rgba(0, 0, 0, .09)',
    z1: '0 1.2px 1.92251px rgba(0, 0, 0, .02), 0 2px 3.68135px rgba(0, 0, 0, .04), 0 1px 5px rgba(0, 0, 0, .05)',
    z2: '0 .14px 2.29266px rgba(0, 0, 0, .0323114), 0 .37px 4.42626px rgba(0, 0, 0, .0476886), 0 3px 7px rgba(0, 0, 0, .09)',
    z3: '0 .08px 2.55728px rgba(0, 0, 0, .0525061), 0 1.28px 5.57858px rgba(0, 0, 0, .0774939), 0 3px 10px rgba(0, 0, 0, .13)',
    z4: '0 .266004px 1.13052px rgba(0, 0, 0, .0686618), 0 .893452px 3.79717px rgba(0, 0, 0, .101338), 0 5px 17px rgba(0, 0, 0, .17)',
    z5: '0 0 2.17382px rgba(0, 0, 0, .0487776), 0 1.75px 6.01034px rgba(0, 0, 0, .07), 0 3.63px 14.4706px rgba(0, 0, 0, .0912224), 0 22px 48px rgba(0, 0, 0, .14)',
} as const;

export const dropShadows = {
    aa: 'drop-shadow(0 0 .880517px rgba(0, 0, 0, .0288)) drop-shadow(0 0 2.29197px rgba(0, 0, 0, .03)) drop-shadow(0 0 5.52px rgba(0, 0, 0, .0543)) drop-shadow(0 0 11px rgba(0, 0, 0, .09))',
    z1: 'drop-shadow(0 1.2px 1.92251px rgba(0, 0, 0, .02)) drop-shadow(0 2px 3.68135px rgba(0, 0, 0, .04)) drop-shadow(0 1px 5px rgba(0, 0, 0, .05))',
    z2: 'drop-shadow(0 .14px 2.29266px rgba(0, 0, 0, .0323114)) drop-shadow(0 .37px 4.42626px rgba(0, 0, 0, .0476886)) drop-shadow(0 3px 7px rgba(0, 0, 0, .09))',
    z3: 'drop-shadow(0 .08px 2.55728px rgba(0, 0, 0, .0525061)) drop-shadow(0 1.28px 5.57858px rgba(0, 0, 0, .0774939)) drop-shadow(0 3px 10px rgba(0, 0, 0, .13))',
    z4: 'drop-shadow(0 .266004px 1.13052px rgba(0, 0, 0, .0686618)) drop-shadow(0 .893452px 3.79717px rgba(0, 0, 0, .101338)) drop-shadow(0 5px 17px rgba(0, 0, 0, .17))',
    z5: 'drop-shadow(0 0 2.17382px rgba(0, 0, 0, .0487776)) drop-shadow(0 1.75px 6.01034px rgba(0, 0, 0, .07)) drop-shadow(0 3.63px 14.4706px rgba(0, 0, 0, .0912224)) drop-shadow(0 22px 48px rgba(0, 0, 0, .14))',
} as const;

export const borderWidth = {
    sm: '1px',
    md: '2px',
    lg: '3px',
    xl: '4px',
    0: '0',
} as const;

export const headingFontSizes = {
    h_xxs: '16px',
    h_xs: '18px',
    h_sm: '20px',
    h_md: '24px',
    h_lg: '28px',
    h_xl: '32px',
    h_xxl: '40px',
} as const;

export const bodyFontSizes = {
    b_xs: '12px',
    b_sm: '14px',
    b_md: '16px',
    b_lg: '18px',
    b_xl: '20px',
    b_xxl: '24px',
} as const;

export const typographyFontSizes = {
    b_xxs: '10px',
    ...bodyFontSizes,
    ...headingFontSizes,
    h_3xl: '48px',
    h_4xl: '56px',
    h_5xl: '64px',
    h_6xl: '80px',
} as const;

export const headingLineHeights = {
    h_xxs: '22px',
    h_xs: '25px',
    h_sm: '28px',
    h_md: '32px',
    h_lg: '36px',
    h_xl: '38px',
    h_xxl: '48px',
} as const;

export const bodyLineHeights = {
    b_xs: '18px',
    b_sm: '22px',
    b_md: '24px',
    b_lg: '26px',
    b_xl: '28px',
    b_xxl: '32px',
} as const;

export const typographyLineHeights = {
    b_xxs: '14px',
    ...bodyLineHeights,
    ...headingLineHeights,
    h_3xl: '56px',
    h_4xl: '66px',
    h_5xl: '74px',
    h_6xl: '92px',
} as const;

export const headingSizes = {
    h_xxs: 'h_xxs',
    h_xs: 'h_xs',
    h_sm: 'h_sm',
    h_md: 'h_md',
    h_lg: 'h_lg',
    h_xl: 'h_xl',
    h_xxl: 'h_xxl',
} as const;

export const bodySizes = {
    b_xs: 'b_xs',
    b_sm: 'b_sm',
    b_md: 'b_md',
    b_lg: 'b_lg',
    b_xl: 'b_xl',
    b_xxl: 'b_xxl',
} as const;

export const typographySizes = {
    b_xxs: 'b_xxs',
    ...bodySizes,
    ...headingSizes,
    h_3xl: 'h_3xl',
    h_4xl: 'h_4xl',
    h_5xl: 'h_5xl',
    h_6xl: 'h_6xl',
} as const;

export const borderRadiuses = {
    none: '0',
    sm: '4px',
    md: '6px',
    lg: '8px',
    xl: '12px',
    '2xl': '16px',
    '3xl': '20px',
    circle: '9999px',
} as const;

export const fontStyle = {
    normal: 'normal',
    italic: 'italic',
    oblique: 'oblique',
} as const;

const primaryFont = '"Macan", "Helvetica Neue", Helvetica, Arial, sans-serif';

export const fontFamily = {
    primary: primaryFont,
    domaine: '"DomaineDisplay", "Helvetica Neue", Helvetica, Arial, sans-serif',
    accent: primaryFont,
    serif: 'Georgia, "Times New Roman", serif',
} as const;

export const fontWeight = {
    light: '300',
    normal: '400',
    semibold: '600',
    bold: '700',
    inherit: 'inherit',
} as const;

export const textDecoration = {
    underline: 'underline',
    overline: 'overline',
    lineThrough: 'line-through',
    none: 'none',
    inherit: 'inherit',
} as const;

export const textOverflow = {
    ellipsis: 'ellipsis',
    unset: 'unset',
} as const;

export const pointerEvents = {
    none: 'none',
} as const;

export const overflow = {
    visible: 'visible',
    hidden: 'hidden',
    scroll: 'scroll',
    auto: 'auto',
    clip: 'clip',
} as const;

export const whiteSpace = {
    nowrap: 'nowrap',
    unset: 'unset',
    preWrap: 'pre-wrap',
} as const;

export const flexDirection = {
    column: 'column',
    row: 'row',
    rowReverse: 'row-reverse',
    columnReverse: 'column-reverse',
} as const;

export const aspectRatio = {
    '16/9': '16/9',
    '1': '1',
    '1.66/1': '1.66/1',
    '1.33/1': '1.33/1',
} as const;

export const textAlign = {
    start: 'start',
    center: 'center',
    end: 'end',
} as const;

export const display = {
    block: 'block',
    inline: 'inline',
    inlineBlock: 'inline-block',
    flex: 'flex',
    inlineFlex: 'inline-flex',
    grid: 'grid',
    inlineGrid: 'inline-grid',
    contents: 'contents',
    none: 'none',
    initial: 'initial',
    webkitBox: '-webkit-box',
} as const;

const BaseFlexAlignment = {
    flexStart: 'flex-start',
    center: 'center',
    flexEnd: 'flex-end',
    stretch: 'stretch',
    baseline: 'baseline',
} as const;

export const justifyContent = {
    ...BaseFlexAlignment,
    spaceAround: 'space-around',
    spaceEvenly: 'space-evenly',
    spaceBetween: 'space-between',
} as const;

export const flexAlignment = {
    ...BaseFlexAlignment,
    baseline: 'baseline',
};

export const flexWrap = {
    nowrap: 'nowrap',
    wrap: 'wrap',
    wrapReverse: 'wrap-reverse',
} as const;

const numberValues = {
    '1': '1',
    '2': '2',
    '3': '3',
    '4': '4',
    '5': '5',
    '6': '6',
    '7': '7',
    '8': '8',
    '9': '9',
    '10': '10',
    '11': '11',
    '12': '12',
    '13': '13',
    '14': '14',
    '15': '15',
    '16': '16',
} as const;

export const gridLine = {
    ...numberValues,
    '-1': '-1',
} as const;

export const gridTemplates = {
    '7_cols': 'repeat(7, 1fr)',
    '12_cols': 'repeat(12, 1fr)',
    '15_cols': 'repeat(15, 1fr)',
    '100%': 'minmax(0, 1fr)',
    '25%_75%': 'minmax(0, 1fr) minmax(0, 3fr)',
    '75%_25%': 'minmax(0, 3fr) minmax(0, 1fr)',
    '70%_30%': 'minmax(0, 7fr) minmax(0, 3fr)',
    '30%_70%': 'minmax(0, 3fr) minmax(0, 7fr)',
    '33%_33%_33%': 'minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) ',
    '50%_50%': 'minmax(0, 1fr) minmax(0, 1fr)',
    '25%_25%_25%_25%': 'minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr)',
    '25%_25%_50%': 'minmax(0, 1fr) minmax(0, 1fr) minmax(0, 2fr)',
    '25%_50%_25%': 'minmax(0, 1fr) minmax(0, 2fr) minmax(0, 1fr) ',
    '50%_25%_25%': 'minmax(0, 2fr) minmax(0, 1fr) minmax(0, 1fr) ',
    '20%_20%_20%_20%_20%': 'minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr)',
} as const;

export const gridAuto = {
    auto: 'auto',
    minContent: 'min-content',
    maxContent: 'max-content',
} as const;

export const boxSizing = {
    borderBox: 'border-box',
    unset: 'unset',
} as const;

export const position = {
    static: 'static',
    relative: 'relative',
    absolute: 'absolute',
    fixed: 'fixed',
    sticky: 'sticky',
} as const;

export const cursor = {
    pointer: 'pointer',
    copy: 'copy',
    auto: 'auto',
    wait: 'wait',
    zoomIn: 'zoom-in',
    zoomOut: 'zoom-out',
    progress: 'progress',
    move: 'move',
    grab: 'grab',
    grabbing: 'grabbing',
    notAllowed: 'not-allowed',
    default: 'default',
} as const;

export const userSelect = {
    none: 'none',
    auto: 'auto',
    text: 'text',
    all: 'all',
} as const;

export const listStyleType = {
    none: 'none',
    decimal: 'decimal',
    initial: 'initial',
} as const;

export const elements = {
    typography: {
        heading: {
            h1: 'h1',
            h2: 'h2',
            h3: 'h3',
            h4: 'h4',
            h5: 'h5',
            h6: 'h6',
        },
        body: {
            small: 'small',
            blockquote: 'blockquote',
            span: 'span',
            p: 'p',
            pre: 'pre',
            b: 'strong',
            strong: 'strong',
            abbr: 'abbr',
            bdi: 'bdi',
            cite: 'cite',
            mark: 'mark',
            time: 'time',
            a: 'a',
            u: 'u',
        },
    },
    box: {
        div: 'div',
        span: 'span',
        article: 'article',
        aside: 'aside',
        footer: 'footer',
        main: 'main',
        nav: 'nav',
        section: 'section',
        address: 'address',
        figcaption: 'figcaption',
        details: 'details',
        figure: 'figure',
        summary: 'summary',
        ul: 'ul',
        li: 'li',
        a: 'a',
        label: 'label',
        header: 'header',
    },
} as const;

export const visibility = {
    visible: 'visible',
    hidden: 'hidden',
    collapse: 'collapse',
} as const;

export const numericBreakpoints = {
    sm: 600,
    md: 900,
    lg: 1160,
    xl: 1400,
    xxl: 1760,
};

export const numericBreakpointsReverse = {
    sm: numericBreakpoints.sm - 1,
    md: numericBreakpoints.md - 1,
    lg: numericBreakpoints.lg - 1,
    xl: numericBreakpoints.xl - 1,
    xxl: numericBreakpoints.xxl - 1,
};

export const breakpoints = {
    sm: `screen and (min-width: ${numericBreakpoints.sm}px)`,
    md: `screen and (min-width: ${numericBreakpoints.md}px)`,
    lg: `screen and (min-width: ${numericBreakpoints.lg}px)`,
    xl: `screen and (min-width: ${numericBreakpoints.xl}px)`,
    xxl: `screen and (min-width: ${numericBreakpoints.xxl}px)`,
} as const;

export const breakpointsReverse = {
    sm: `screen and (max-width: ${numericBreakpoints.sm - 1}px)`,
    md: `screen and (max-width: ${numericBreakpoints.md - 1}px)`,
    lg: `screen and (max-width: ${numericBreakpoints.lg - 1}px)`,
    xl: `screen and (max-width: ${numericBreakpoints.xl - 1}px)`,
    xxl: `screen and (max-width: ${numericBreakpoints.xxl - 1}px)`,
} as const;

export const numericAnimationDurations = {
    fast1: 0.07 * 1000,
    fast2: 0.1 * 1000,
    fast3: 0.12 * 1000,
    moderate1: 0.2 * 1000,
    moderate2: 0.25 * 1000,
    moderate3: 0.3 * 1000,
    slow1: 0.37 * 1000,
    slow2: 0.4 * 1000,
    slow3: 0.5 * 1000,
} as const;

export const animationDuration = {
    fast1: `${numericAnimationDurations.fast1}ms`,
    fast2: `${numericAnimationDurations.fast2}ms`,
    fast3: `${numericAnimationDurations.fast3}ms`,
    moderate1: `${numericAnimationDurations.moderate1}ms`,
    moderate2: `${numericAnimationDurations.moderate2}ms`,
    moderate3: `${numericAnimationDurations.moderate3}ms`,
    slow1: `${numericAnimationDurations.slow1}ms`,
    slow2: `${numericAnimationDurations.slow2}ms`,
    slow3: `${numericAnimationDurations.slow3}ms`,
} as const;

export const animationTiming = {
    easeIn: 'cubic-bezier(0, 0.7, 0, 1)',
    easeOut: 'cubic-bezier(0, 0, 1, 0.3)',
    easeInOut: 'cubic-bezier(0.75, 0, 0.25, 1)',
    linear: 'cubic-bezier(0, 0, 1, 1)',
} as const;

export const outlineOffset = {
    '0': '0',
    sm: '1px',
    lg: '4px',
} as const;

export const outlineWidth = {
    sm: '1px',
    md: '2px',
} as const;

export const overflowWrap = {
    anywhere: 'anywhere',
    breakWord: 'break-word',
} as const;

export const wordBreak = {
    breakAll: 'break-all',
    keepAll: 'keep-all',
} as const;

const BASE_Z_INDEX = 10000;

export const zIndex = {
    auto: 'auto',
    '-1': '-1',
    '0': '0',
    '1': '1',
    '2': '2',
    overlayBackground: `${BASE_Z_INDEX + 1300}`,
    overlay: `${BASE_Z_INDEX + 1400}`,
    popover: `${BASE_Z_INDEX + 1500}`,
    toast: `${BASE_Z_INDEX + 1600}`,
    tooltip: `${BASE_Z_INDEX + 1700}`,
    educationTooltip: `${BASE_Z_INDEX + 1900}`,
} as const;

export const opacity = {
    '0': '0',
    '0.1': '0.1',
    '0.2': '0.2',
    '0.5': '0.5',
    '0.6': '0.6',
    '0.8': '0.8',
    '0.9': '0.9',
    '1': '1',
} as const;

export const appearance = {
    none: 'none',
    textfield: 'textfield',
} as const;

export const objectFit = {
    none: 'none',
    unset: 'unset',
    fill: 'fill',
    contain: 'contain',
    cover: 'cover',
} as const;

export const webkitBoxOrient = {
    vertical: 'vertical',
} as const;

export {
    semanticBackgroundColors,
    semanticBodyColors,
    semanticBorderColors,
    semanticHeadingColors,
    semanticLinkColors,
    semanticTokens,
    semanticValidationColors,
};
